import { yup } from '@framework/validation';
import { useEffect, useRef } from 'react';
import { ControllerRenderProps, useFormContext } from 'react-hook-form';

/**
 * Hook con un effect che reimposta il valore di un campo
 * quando viene disabilitato.
 */
export function useResetDefaultOnDisableEffect(
  field: ControllerRenderProps<any, any>,
  enabled: boolean | undefined,
  schema: yup.MixedSchema | null | undefined,
) {
  // Ref utilizzata per evitare il rerender loop
  const enabledRef = useRef(enabled);

  const context = useFormContext();

  // Questo useEffect serve per resettare il valore del campo
  // quando viene disabilitato
  useEffect(() => {
    // console.log('useResetDefaultOnDisableEffect', field.name, enabled, schema);
    // Se non c'è lo schema, non fare nulla
    if (!schema) return;

    // Se il valore di enabled non cambia, non fare nulla
    if (enabledRef.current === enabled) return;

    enabledRef.current = enabled;

    // Se il valore è cambiato e il campo è abilitato,
    // registra l'informazione e non fare nulla
    if (enabled !== false) return;

    // Altrimenti se il campo è stato disabilitato,
    // registra l'informazione e resetta il valore
    // del campo a quello di default
    const defaultValue = schema.getDefault();

    context.setValue(
      field.name,
      defaultValue === undefined ? null : defaultValue,
      {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      },
    );
  }, [field, enabled, schema, context]);
}
